import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { Rest } from 'app/rest/rest_client';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { SanctionReasonService } from 'app/modules/vehicle-inventory/services/table-management/sanctionReason.service';

@Component({
    selector: 'app-sanction-reason-form',
    templateUrl: './sanction-reason-form.component.html',
    styleUrls: ['./sanction-reason-form.component.css'],
    providers: [SanctionReasonService],
    standalone: false,
})
export class SanctionReasonFormComponent extends EntityFormComponent<Rest.SanctionReason>
    implements OnInit {

    title: string;

    disableSave: boolean;
    disabeChangeStatus: boolean;

    constructor(
        private sanctionReasonService: SanctionReasonService,
        notificationsService: NotificationsService,
        protected i18n: I18nService,
        protected authenticationService: AuthenticationService,
        public translateService: TranslateService,
    ) {
        super(sanctionReasonService, notificationsService, i18n, authenticationService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    beforeShow() {
        if (this.isNew) {
            this.title = this.translateService.instant('tableManagement.sanctionReason.createSanctionReason');
        } else {
            this.title = this.translateService.instant('tableManagement.sanctionReason.editSanctionReason');
        }
    }
}

